module.exports = {
          srcSet: __webpack_public_path__ + "81bbb263c7718b43897d00e792f19811-2336.png"+" 2336w",
          images:[ {path: __webpack_public_path__ + "81bbb263c7718b43897d00e792f19811-2336.png",width: 2336,height: 444}],
          src: __webpack_public_path__ + "81bbb263c7718b43897d00e792f19811-2336.png",
          toString:function(){return __webpack_public_path__ + "81bbb263c7718b43897d00e792f19811-2336.png"},
          placeholder: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAACCAYAAABhYU3QAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAXUlEQVR4nAFSAK3/AOR3/fzRfub/snrO/q+D0f+8iub/137D/9x/pP/Viaf+0pRz/+uSMPoAxiTy/Lw36/+gUNH+nGXI/6Zn1/+0YKD/w2qk/8p+2v7CmKX/3YeO+pKVOvFX+60HAAAAAElFTkSuQmCC",
          width: 2336,
          height: 444
        }